module.exports = __webpack_public_path__ + "static/media/appstorebadge_en.2928664f.svg";